import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

/** Whether a batch reached a patient or a picking list; treated as used until both answers are complete. */
export function useBatchUsage(id: string | undefined) {
  const [movement, movementResult] = useQuery(queries.stocks.getBatchUsageMovement(id || ''))
  const [orderLink, orderLinkResult] = useQuery(queries.stocks.getBatchOrderLink(id || ''))

  const isLoading = movementResult.type !== 'complete' || orderLinkResult.type !== 'complete'
  const isUsed = Boolean(movement || orderLink)

  return {isUsed, isLoading}
}
